import { render, staticRenderFns } from "./AddAllocationPlan.vue?vue&type=template&id=5795953d"
import script from "./AddAllocationPlan.vue?vue&type=script&lang=js"
export * from "./AddAllocationPlan.vue?vue&type=script&lang=js"
import style0 from "./AddAllocationPlan.vue?vue&type=style&index=0&id=5795953d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports